import React, { ChangeEvent } from "react";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AgentFormState } from "../../../types/agentTypes";
import Provider from "../../../enum/Provider.enum";
import { FieldColumn, FieldRow, Section, SectionTitle } from "../styles";

type AddressesSectionProps = {
  formData: AgentFormState;
  provider: Provider;
  onChange: (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>,
  ) => void;
};

const AddressesSection = ({
  formData,
  provider,
  onChange,
}: AddressesSectionProps) => {
  const { t } = useTranslation();

  return (
    <Section>
      <SectionTitle>{t("createAgent.addresses.title")}</SectionTitle>

      <FieldRow>
        <FieldColumn>
          <TextField
            size="small"
            label={t("createAgent.addresses.postal")}
            name="post_adress"
            value={formData.post_adress ?? ""}
            fullWidth
            required
            onChange={onChange}
          />
        </FieldColumn>

        {provider === Provider.ARMENIA && (
          <FieldColumn>
            <TextField
              size="small"
              label={t("createAgent.addresses.postalAm")}
              name="address_am"
              value={formData.address_am ?? ""}
              fullWidth
              onChange={onChange}
            />
          </FieldColumn>
        )}
      </FieldRow>
    </Section>
  );
};

export default AddressesSection;
